import { AppLayout } from "@/components/layout/AppLayout";
import { AppProvider, useApp } from "@/context/AppContext";
import { LegacyAppContent } from "@/features/LegacyAppContent";
import "@/main.css";
import { Toaster } from "sonner";

function AppContent() {
  const { isAuthenticated } = useApp();

  // Render without layout when not authenticated (login page)
  if (!isAuthenticated) {
    return <LegacyAppContent />;
  }

  // Render with layout when authenticated
  return (
    <AppLayout data-testid="app-authenticated">
      <LegacyAppContent />
    </AppLayout>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
      <Toaster />
    </AppProvider>
  );
}

export default App;
